import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {ContractBalance} from "../../../../shared/interface/contract-balance";
import {TemplateService} from "../../../../shared/services/template.service";
import {DictService} from "../../../../shared/services/dict.service";
import {DownloaderService} from "../../../../shared/services/downloader.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContractService} from "../../../../shared/services/contract.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {UserPermissions} from "../../../../shared/interface/user-permissions";

@Component({
  selector: 'app-contract-initial-balance-details-view',
  templateUrl: './contract-initial-balance-details-view.component.html',
  styleUrls: ['./contract-initial-balance-details-view.component.scss']
})
export class ContractInitialBalanceDetailsViewComponent implements OnInit, OnDestroy {
  @Input() contractBalance: Observable<ContractBalance>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  contractBalanceObject?: ContractBalance;
  displayedColumns: string[] = ['net', 'note', 'date', 'user'];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private templateService: TemplateService,
    private dictService: DictService,
    private downloader: DownloaderService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private contractService: ContractService,
    private router: Router,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.loadContractBalance();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  modify(): void {
    this.modifyClicked.emit();
  }

  loadContractBalance(): void
  {
    this.contractBalance
      .pipe(takeUntil(this.destroyed$))
      .subscribe((contractBalance: ContractBalance) => {
        this.contractBalanceObject = contractBalance;
      });
  }

}
